export default function firstOrDefault(enumerable, predicate) {
    if (predicate !== undefined) {
        enumerable = enumerable.where(predicate);
    }
    const en = enumerable.getEnumerator();
    if (en.moveNext()) {
        return en.current;
    }
    return null;
}
